module.exports = __webpack_public_path__ + "img/satellitepoi.a396833f.png";